module.exports = __webpack_public_path__ + "media/bootstrap-icons/filter-668630e0.svg";